import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  FloatingLabelInput,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components";
import { useI18n } from "@/context/i18n";

import { IForgotPasswordFormValues } from "../../login.types";

export interface IForgotPasswordProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  form: UseFormReturn<IForgotPasswordFormValues>;
  onSuccess?: () => void;
  handleForgotPassword: () => Promise<void>;
}

export const ForgotPassword: React.FC<IForgotPasswordProps> = ({
  open,
  onOpenChange,
  form,
  handleForgotPassword,
}) => {
  const { t } = useI18n();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader className="mb-5">
          <DialogTitle className="text-xl font-bold">
            {t("auth.forgotPassword")}
          </DialogTitle>
          <DialogDescription className="text-sm">
            {t("auth.forgotPasswordDescription")}
          </DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form
            className="space-y-4"
            onSubmit={form.handleSubmit(handleForgotPassword)}
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <FloatingLabelInput
                      label={t("auth.email")}
                      type="email"
                      placeholder={t("generic.yourEmail")}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <Button type="submit" className="w-full">
              {t("generic.confirm")}
            </Button>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
